enum ContractInfoTabControl {
  ITENS = 'ITENS',
  INSTANCIAS = 'INSTÂNCIAS',
  REAJUSTE = 'REAJUSTE',
  DESCONTOS = 'DESCONTOS',
  ACRESCIMOS = 'ACRÉSCIMOS',
  LINKS = 'LINKS',
  INFORMACOES_ADICIONAIS = 'INFORMAÇÕES ADICIONAIS',
  HISTORICO = 'HISTÓRICO',
  SOLICITAR_CANCELAMENTO = 'SOLICITAÇÃO DE CANCELAMENTO',
}

export default ContractInfoTabControl;
